import React from 'react';

export const formatJoeditData = (data: string): JSX.Element => {
    return (
        <div dangerouslySetInnerHTML={{ __html: data }} />
    );
};